export class LanguageSelect {
  $language;
  $current;
  $currentValue;
  $dropdownItem;
  $control;

  constructor() {}

  initSelect() {
    this.$language = $('.language');
    this.$current = this.$language.find('.language-current');
    this.$currentValue = this.$language.find('.language-current-value');
    this.$dropdownItem = this.$language.find('.language-dropdown-item');
    this.$control = this.$language.find('.language-control');

    const defaultLang = this.$language.data('lang');
    const $defaultLangItem = this.$language.find(
      `.language-dropdown-item[data-value="${defaultLang}"]`
    );
    this.changeValue($defaultLangItem);
    this.changeSelect();
  }

  changeValue($item) {
    this.$language.find('.active').removeClass('active');
    $item.addClass('active');
    this.$control.val($item.data('value'));
    this.$currentValue.text($item.data('placeholder'));
    this.$language.removeClass('show-dropdown');
  }

  changeSelect() {
    this.$current.on('click', () => {
      this.$language.toggleClass('show-dropdown');
    });

    this.$dropdownItem.on('click', (e) => {
      this.changeValue($(e.currentTarget));
    });
  }
}
